import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { AboutFormControlProps, AboutFormData } from '../../types';
import { CollapseCheckbox } from '../components/collapseCheckbox';
import { TermostatstyringGulvvarme } from '../components/termostatstyringGulvvarme';
import { TermostatstyringGulv } from '../../../../../utils/registerEnums';

export const Gulvvarme: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext<AboutFormData>();

  return (
    <Controller
      name="oppvarming.oppvarmingElektrisk.gulvvarme.selected"
      control={control}
      render={({ field: { value, onChange } }) => {
        return (
          <CollapseCheckbox
            labelKey="register.tekniskUtstyr.gulvvarme.label"
            checked={!!value}
            onChange={(checked) => {
              onChange(checked);

              const defaultValue = {
                termostatstyring: TermostatstyringGulv.Ukjent
              };

              setValue('oppvarming.oppvarmingElektrisk.gulvvarme.value', checked ? defaultValue : undefined);
            }}
          >
            <Controller
              name="oppvarming.oppvarmingElektrisk.gulvvarme.value"
              control={control}
              render={({ field: { value, onChange }, fieldState: { error } }) => {
                const onValueChange = (val: TermostatstyringGulv) => {
                  onChange({ termostatstyring: val });
                };
                const termostatValue = value?.termostatstyring || TermostatstyringGulv.Ukjent;

                return <TermostatstyringGulvvarme value={termostatValue} error={error} onChange={onValueChange} />;
              }}
            />
          </CollapseCheckbox>
        );
      }}
    />
  );
};
